import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Button } from 'foundations-components/transitional/components/Button';
import { getMeetingsSettingsLink } from 'MeetingsAdmin/utils/utils';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export default class DefaultLinkPopover extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      open: false
    };
    this.toggleOpen = () => {
      const {
        clickDefaultLinkTooltip
      } = this.props;
      const {
        open
      } = this.state;
      if (!open) {
        clickDefaultLinkTooltip();
      }
      this.setState({
        open: !open
      });
    };
    this.handleOpenChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        open: value
      });
    };
  }
  render() {
    const {
      open
    } = this.state;
    return /*#__PURE__*/_jsx(Popover, {
      inlineSize: "264px",
      open: open,
      closeOnOutsideClick: true,
      onOpenChange: this.handleOpenChange,
      use: "tooltip",
      content: {
        body: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "adminHeader.table.tooltip.body_jsx",
          options: {
            href: getMeetingsSettingsLink(),
            use: 'on-dark',
            external: true
          },
          elements: {
            Link
          }
        })
      },
      placement: "right",
      children: /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: this.toggleOpen,
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "adminHeader.table.tooltip.visibleText"
          })
        })
      })
    });
  }
}
DefaultLinkPopover.propTypes = {
  clickDefaultLinkTooltip: PropTypes.func.isRequired
};